module.exports = __webpack_public_path__ + "static/3b_city-states_in_mesopotamia-68de3fe6f3aaea0558cbfb4ef96f1c1b.pdf";